import { FunctionComponent } from "react";
import classnames from "classnames";

import { PNLAndWhatIfSize } from "../PNLAndWhatIf/PNLAndWhatIf.types";
import { PNLAndWhatIf } from "../PNLAndWhatIf/PNLAndWhatIf.web";
import { hasPNLAndWhatIfValues } from "../../helpers/pnl-and-what-if";
import { GenericIcon } from "@ppb/the-wall-icons/GenericIcon/GenericIcon";
import { SupportingContentIconName } from "@ppb/the-wall-icons";

import type { RunnerViewModel } from "./Runner.types";
import styles from "./Runner.web.css";

const RunnerDetails: FunctionComponent<
  Pick<RunnerViewModel, "name" | "titleAddon" | "pnlAndWhatIf"> & { isMarketGraphsActive?: boolean }
> = ({ name, titleAddon, pnlAndWhatIf, isMarketGraphsActive }) => {
  const shouldRenderPNL = hasPNLAndWhatIfValues(pnlAndWhatIf);
  return (
    <>
      <div className={styles.runnerContainer}>
        {isMarketGraphsActive ? (
          <span className={styles.runnerMarketGraphIcon}>
            <GenericIcon name={SupportingContentIconName.MARKET_GRAPH} color="var(--runner-icon-colour)" />
          </span>
        ) : null}
        <p className={styles.runnerName}>{name}</p>
        {titleAddon}
      </div>
      {shouldRenderPNL ? (
        <div className={styles.pNLAndWhatIfContainer}>
          <PNLAndWhatIf
            pnl={pnlAndWhatIf?.pnl}
            rawPnl={pnlAndWhatIf?.rawPnl}
            pnlLose={pnlAndWhatIf?.pnlLose}
            rawPnlLose={pnlAndWhatIf?.rawPnlLose}
            whatIf={pnlAndWhatIf?.whatIf}
            rawWhatIf={pnlAndWhatIf?.rawWhatIf}
            whatIfLose={pnlAndWhatIf?.whatIfLose}
            rawWhatIfLose={pnlAndWhatIf?.rawWhatIfLose}
            size={PNLAndWhatIfSize.SMALL}
            pnlAndWhatIfEachWay={pnlAndWhatIf?.pnlAndWhatIfEachWay}
          />
        </div>
      ) : null}
    </>
  );
};

export const Runner: FunctionComponent<RunnerViewModel> = ({
  children,
  className,
  name,
  titleAddon,
  isMarketDepthActive,
  isMarketGraphsActive,
  pnlAndWhatIf,
  onClick,
}) => {
  const containerClasses = classnames(styles.runnerLine, className, {
    [styles.runnerLineMarketDepth]: isMarketDepthActive,
  });

  const runnerInnerContainerClasses = classnames(styles.runnerInnerContainer, {
    [styles.runnerInnerContainerMarketDepth]: isMarketDepthActive,
  });

  return (
    <div className={containerClasses}>
      {onClick ? (
        <button className={`${runnerInnerContainerClasses} ${styles.runnerButton}`} onClick={onClick}>
          <RunnerDetails
            name={name}
            titleAddon={titleAddon}
            pnlAndWhatIf={pnlAndWhatIf}
            isMarketGraphsActive={isMarketGraphsActive}
          />
        </button>
      ) : (
        <div className={runnerInnerContainerClasses}>
          <RunnerDetails name={name} titleAddon={titleAddon} pnlAndWhatIf={pnlAndWhatIf} isMarketGraphsActive={false} />
        </div>
      )}

      {children}
    </div>
  );
};
